import React from 'react';

import * as Types from '../types';

import Mask, { MASK_TYPE } from '../Mask';

interface IProps extends Types.FieldProps {
  nextElementId?: string;
}

const CadastralNumberField: React.FC<IProps> = ({ ...props }) => (
  <Mask
    {...props}
    type={MASK_TYPE.NUMBER}
    lazy
    mask={[
      {
        mask: '00:00:000000000'
      },
      {
        mask: '00:00:00:00:00:0000'
      },
      {
        mask: '00:00:00:00:00:00000'
      },
      {
        mask: '00:00:00:00:00:0000/00'
      },
      {
        mask: '00:00:00:00:00:0000/000'
      },
      {
        mask: '00:00:00:00:00:0000/0000'
      },
      {
        mask: '00:00:00:00:00:00000/000'
      },
      {
        mask: '00:00:00:00:00:00000:000'
      },
      {
        mask: '00:00:00:00:00:0000:0000'
      },
      {
        mask: '00:00:00:00:00:0000:0000:000'
      },
      {
        mask: '00:00:00:00:00:0000:0000:000/00'
      }
    ]}
    unmask={false}
  />
);

export default CadastralNumberField;
